import { useEffect, useState } from 'react'
import { Notes } from 'components/common/Notes'
import { toFormData } from './serializers'
import { AddNoteModal } from 'components/common/modals/AddNoteModal'
import {
  makeLeadsGetRequest,
  makeLeadsPostRequest,
  makeLeadsPutRequest,
  makeLeadsDeleteRequest
} from 'utils/api'
import { useParams } from 'react-router-dom'
import { useImmer } from 'use-immer'

const LeadNotes = () => {
  const [showAddNoteModal, setShowAddNoteModal] = useState(false)
  const [selectedNote, setSelectedNote] = useState(null)
  const [notes, setNotes] = useImmer([])
  const { id: leadId } = useParams()

  useEffect(() => {
    ;(async () => {
      const notes = await makeLeadsGetRequest(`/v1/note/lead/${leadId}`)
      setNotes(notes)
    })()
  }, [leadId, setNotes])

  const toggleAddNoteModal = selectedNote => {
    setShowAddNoteModal(!showAddNoteModal)
    setSelectedNote(selectedNote)
  }

  const addNote = async (cb, contact, files, note, dateEntered, destroyEditor) => {
    const response = await makeLeadsPostRequest(
      '/v1/note',
      toFormData(contact, files, note, leadId, dateEntered)
    )
    setNotes([...notes, response])
    destroyEditor?.()
    cb?.()
  }

  const updateNote = async (noteId, cb, contact, files, note, dateEntered, destroyEditor) => {
    const response = await makeLeadsPutRequest(
      `/v1/note/${noteId}`,
      toFormData(contact, files, note, leadId, dateEntered)
    )
    setNotes(draft => {
      const index = draft.findIndex(item => item.id === response.id)
      if (~index) {
        draft[index] = response
      }
    })
    destroyEditor?.()
    cb?.()
  }

  const deleteNote = async (noteId, cb, contact, files, note, dateEntered, destroyEditor) => {
    await makeLeadsDeleteRequest(`/v1/note/${noteId}`)
    const arr = [...notes]
    const index = arr.findIndex(item => item.id === noteId)
    if (~index) {
      arr.splice(index, 1)
    }
    setNotes(arr)
    destroyEditor?.()
    cb?.()
  }

  return (
    <div style={{ overflow: 'hidden' }}>
      <AddNoteModal
        toggleAddNoteModal={toggleAddNoteModal}
        showAddNoteModal={showAddNoteModal}
        selectedNote={selectedNote}
        addNote={addNote}
        updateNote={updateNote}
      />
      <Notes notes={notes} toggleAddNoteModal={toggleAddNoteModal} deleteNote={deleteNote} />
    </div>
  )
}

export default LeadNotes
